export enum JobRuleTag {
  ProxySubtitleNative = "ProxySubtitleNative",
  ProxySubtitle25fps = "ProxySubtitle25fps",
  WaveformGenerate = "WaveformGenerate",
}
